import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Area } from "../../master-data/master-data.model";

@Component({
    selector: "app-branches-areas-edit",
    templateUrl: "./branches-areas-edit.component.html",
    styleUrls: ["./branches-areas-edit.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BranchesAreasEditComponent {
  private formBuilder = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<BranchesAreasEditComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);


  form = this.formBuilder.group({
    selectedArea: [null, [Validators.required]],
  });

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onSave() {
    const area = this.form.value.selectedArea;
    this.dialogRef.close(area);
  }
}
